import { InvoiceListTemplate, InvoiceListTemplateProps } from "./template";

export type InvoiceListProps = InvoiceListTemplateProps;

export const InvoiceList = (props: InvoiceListProps): JSX.Element => {
  return <InvoiceListTemplate {...props} />;
};
